export default __webpack_public_path__ + "static/media/Schedule Appt.ea7ad2da.svg";